import { useModal } from '@ebay/nice-modal-react'
import { Link, useMatches } from '@tanstack/router'
import { useTranslation } from 'react-i18next'

import casino from '../../assets/common/casino.webp'
import deportes from '../../assets/common/deportes.webp'
import livechat from '../../assets/common/livechat.webp'
import recent from '../../assets/common/recent.webp'
import useGeoCheck from '../../hooks/useGeoCheck'
import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import LoginModal from '../common/log-in-modal'

const BottomNav = () => {
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const setIsChatVisible = useBoundStore(state => state.common.setIsChatVisible)
  const username = useBoundStore(state => state.user.username)
  const { geoCheck } = useGeoCheck()
  const logInModal = useModal(LoginModal)
  const { t, i18n } = useTranslation(['drawer', 'casino', 'duplicateAccount'])
  const { language } = i18n
  const matches = useMatches()
  // Use the resolved leaf-match pathname (params already interpolated, e.g.
  // '/casino/lobby'), not the route template (`route.fullPath` is '/casino/$category'
  // for param routes, so `.includes(tab.link)` could never match). This value is
  // reactive to navigation since `useMatches` re-renders on route changes.
  const currentPathname = String(matches.slice(-1)[0]?.pathname ?? '')

  const TABS = [
    {
      id: 'sports',
      icon: deportes,
      label: t('drawer:sports'),
      link: +pending_bind === 0 || +pending_bind === 2 ? undefined : '/sports',
      onLinkClick: () => {
        if (+pending_bind === 0 || +pending_bind === 2)
          setIsPendingDepositVisible(true)
      },
      isProtected: false,
    },
    {
      id: 'casino',
      icon: casino,
      label: 'Casino',
      link: '/casino/lobby',
      onLinkClick: null,
      isProtected: false,
    },
    {
      id: 'recent',
      icon: recent,
      label: t('casino:recent'),
      link: language === 'es' ? '/casino/jugados' : '/casino/recent',
      onLinkClick: null,
      isProtected: false,
    },
    {
      id: 'livechat',
      icon: livechat,
      label: t('duplicateAccount:contact'),
      link: undefined,
      onLinkClick: () => setIsChatVisible(true),
      isProtected: true,
    },
  ] as const

  return (
    <div className="fixed rounded-full w-[calc(100%-32px)] bottom-2 left-4 z-[100] bg-[rgba(255,255,255,0.75)] dark:bg-[rgba(10,10,10,0.75)] grid grid-cols-4 px-3 h-[60px] items-center transition-all duration-[0.2s] ease-[ease-in-out] border border-solid border-[color-mix(in_srgb,var(--highlight-gold)_25%,transparent)] dark:border-[color-mix(in_srgb,var(--highlight-gold)_35%,transparent)] shadow-[0px_-2px_5px_color-mix(in_srgb,var(--highlight-gold)_15%,transparent)] dark:shadow-[0_0_12px_color-mix(in_srgb,var(--highlight-gold)_30%,transparent)]">
      {TABS.map(tab => {
        const isActive = tab.link ? currentPathname.includes(tab.link) : false
        return (
        <Link
          to={tab.isProtected && !username ? undefined : tab.link}
          key={tab.label}>
          <div
            className={`flex flex-col items-center group ${
              isActive ? 'active' : ''
            }`}
            onClick={() => {
              if (tab.isProtected && !username) {
                geoCheck(logInModal.show)
                return
              }
              tab.onLinkClick?.()
            }}>
            <div className="w-10 h-10 rounded-full flex justify-center items-center transition-all duration-200 ease-in-out mb-0.5 relative">
              <div
                className={classNames(
                  'w-10 h-10 object-contain',
                  tab.id === 'livechat' || tab.id === 'recent' ? 'p-1' : '',
                )}>
                <img src={tab.icon} alt={tab.label} />
              </div>
            </div>
            <p
              className={`text-[8px] font-['Syncopate-Bold'] uppercase text-center ${
                isActive ? 'text-highlight-gold' : 'text-[var(--txt)]'
              }`}>
              {tab.label}
            </p>
          </div>
        </Link>
        )
      })}
    </div>
  )
}

export default BottomNav
